import { RootState } from '../../store'
import { errorLogger as logError } from './ErrorHandler'

export type LoggerContext = {
  globalState?: RootState
  additionalContext?: Record<string, unknown>
}
export const errorLogger =
  ({ globalState, additionalContext }: LoggerContext = {}) =>
  (error: Error, request_id?: string) => {
    const activeProducts =
      globalState?.AccountData?.user?.partnerData?.activeProducts
    const partnerId =
      globalState?.AccountData['user']?.partnerData?.partnerId ?? ''
    const oktaUserId = globalState?.userProfile?.userProfile?.idpUserId ?? ''
    const user = globalState?.userProfile?.userProfile

    const logContext = {
      partnerId:
        partnerId && partnerId !== 'null' && partnerId !== 'undefined'
          ? partnerId
          : 'no partner ID',
      oktaUserId:
        oktaUserId && oktaUserId !== 'null' && oktaUserId !== 'undefined'
          ? oktaUserId
          : 'no okta user id',
      envVariables: process.env || 'no env variables available',
      activeProducts: activeProducts || 'no active products',
      user_roles: user?.roles || 'no roles available',
      time_zone: user?.timeZone || 'no timezone available',
      request_id: request_id,
      ...additionalContext,
    }
    logError(error as Error, {
      ...logContext,
      error: error,
    })
  }
